function getTenantIdAtual() {
  return process.env.REACT_APP_TENANT_ID?.trim().toUpperCase() ?? "";
}

const TENANT_ORG_CONFIG = {
  DEFAULT: {
    nomeAbreviado: "A SUPERINTENDÊNCIA ESTADUAL DE MEIO AMBIENTE – SEMACE",
    descricao:
      ", autarquia estadual criada pela Lei Estadual nº 11.411, de 28 de dezembro de 1.987, alterada pela Lei Complementar nº 231 de 13 de janeiro de 2021, inscrita no Cadastro Nacional de Pessoa Jurídica sob o número 11.822.269/0001-70",
  },
  NR: {
    nomeAbreviado: "A SECRETARIA DE MEIO AMBIENTE DE NOVA RUSSAS – SEMA",
    descricao:
      ", criada pela Lei Municipal nº 473/99, de 31 de dezembro de 1.999, alterada pela Lei Municipal nº 1.613 de 02 de maio de 2025",
  },
  NO: {
    nomeAbreviado: "A AUTARQUIA MUNICIPAL DE MEIO AMBIENTE DE NOVO ORIENTE – AMANO",
    descricao:
      ", criada pela Lei Municipal n° 845/2021, de 08 de dezembro de 2021",
  },
  PRG: {
    nomeAbreviado:
      "A SECRETARIA DE MEIO AMBIENTE, ECOTURISMO E TURISMO SUSTENTÁVEL – SEMAETS",
    descricao:
      ", criada pela Lei Municipal n° 244/2025, de 7 de julho de 2025",
  },
};

export function getTenantOrgIdentificacao() {
  return TENANT_ORG_CONFIG[getTenantIdAtual()] || TENANT_ORG_CONFIG.DEFAULT;
}

const NOME_ORGAO_PUBLICACAO_PADRAO =
  "Superintendência Estadual do Meio Ambiente - SEMACE";

const TENANT_NOME_ORGAO_PUBLICACAO = {
  NR: "Secretaria de Meio Ambiente de Nova Russas – SEMA",
  NO: "Autarquia Municipal de Meio Ambiente de Novo Oriente – AMANO",
  PRG: "Secretaria de Meio Ambiente, Ecoturismo e Turismo Sustentável – SEMAETS",
};

export function getNomeOrgaoPublicacaoPedido() {
  return (
    TENANT_NOME_ORGAO_PUBLICACAO[getTenantIdAtual()] || NOME_ORGAO_PUBLICACAO_PADRAO
  );
}

const TENANT_LEI_MUNICIPAL_ANEXO_I = {
  NR: "1291/2021",
  // TODO: obter lei municipal do Anexo I de Novo Oriente (NO) e Poranga
};

const LEI_MUNICIPAL_NAO_CONFIGURADA =
  "LEI MUNICIPAL NAO CONFIGURADA, ENTRAR EM CONTATO COM O SUPORTE";

export function getLeiMunicipalAnexoI() {
  return TENANT_LEI_MUNICIPAL_ANEXO_I[getTenantIdAtual()] || LEI_MUNICIPAL_NAO_CONFIGURADA;
}

const TENANT_SIGLA_ORGAO = {
  NR: "SEMA",
  // TODO: confirmar sigla curta de Novo Oriente (NO) e Poranga
};

const SIGLA_ORGAO_NAO_CONFIGURADA =
  "SIGLA DO ORGAO NAO CONFIGURADA, ENTRAR EM CONTATO COM O SUPORTE";

export function getSiglaOrgao() {
  return TENANT_SIGLA_ORGAO[getTenantIdAtual()] || SIGLA_ORGAO_NAO_CONFIGURADA;
}

const TENANT_MUNICIPIO = {
  NR: { municipio: "Nova Russas", uf: "CE" },
  NO: { municipio: "Novo Oriente", uf: "CE" },
  PRG: { municipio: "Poranga", uf: "CE" },
};

const MUNICIPIO_NAO_CONFIGURADO = {
  municipio: "MUNICIPIO NAO CONFIGURADO, ENTRAR EM CONTATO COM O SUPORTE",
  uf: "",
};

export function getTenantMunicipio() {
  return TENANT_MUNICIPIO[getTenantIdAtual()] || MUNICIPIO_NAO_CONFIGURADO;
}

const CDNSLAM_INCISO_BY_ATIVIDADE = {
  139: "VI",  // DistribuicaoAte15kV
  140: "VI",  // Distribuicao15a138kV
};

// Atividades que usam Art. 9 (sem inciso)
const CDNSLAM_ARTIGO9_ATIVIDADES = new Set([0, 1, 2, 3, 4, 9, 10]);

export function getCdnslamFundamentoLegal(atividadeEmpreendimento) {
  const valor = Number(atividadeEmpreendimento);
  const isArtigo9 = CDNSLAM_ARTIGO9_ATIVIDADES.has(valor);
  const inciso = isArtigo9 ? undefined : CDNSLAM_INCISO_BY_ATIVIDADE[valor];
  const artigo = isArtigo9 ? "9º" : "8º";

  return {
    artigo,
    inciso,
    trechoTextoPrincipal: inciso
      ? `, inciso ${inciso}, da Lei nº 15.190`
      : ` da Lei nº 15.190`,
    hipoteseLegal: inciso
      ? `Lei nº 15.190, Art. ${artigo}, inciso ${inciso}`
      : `Lei nº 15.190, Art. ${artigo}`,
  };
}
